import actions from "../../core/commands/commandNames";
import keybinds from "../../core/commands/inputKeys";
import { warnInDev } from "../../debug";

export function getEntryFromConfig<T>(
  config: Record<string, Record<string, T>>,
  bindings: string | string[],
  value = ""
): T | undefined {
  let binding;
  if (Array.isArray(bindings)) {
    let name;
    const length = bindings.length;
    for (let i = 0; i < length; i++) {
      binding = config[bindings[i]];
      if (binding) {
        name = binding[value] || binding.any;
        if (name) {
          return name;
        }
      } else {
        warnInDev(`Invalid binding: ${bindings[i]} provided`);
      }
    }
  } else {
    binding = config[bindings];
    return binding[value] || binding.any;
  }
}

export const getInputNameForKey = (
  bindings: string | string[],
  keyCode: string
) => getEntryFromConfig(keybinds, bindings, keyCode);

export const getActionNameFromInput = (
  bindings: string | string[],
  input: string | undefined
) => getEntryFromConfig(actions, bindings, input);
